interface BuildAgentUrlParams {
  baseUrl: string;
  aiPort?: string | null;
  path: string;
}

export const buildAgentUrl = ({
  baseUrl,
  aiPort,
  path,
}: BuildAgentUrlParams): string =>
  `${baseUrl}${aiPort ? `:${aiPort}` : ''}${path}`;
